<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>CARGAR ARCHIVO</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="{ maxScrollbarLength: 60, wheelSpeed: .60 }">

      <div class="py-2 px-6">
        <div class="vx-row">
            <div class="vx-col w-full">
              <p v-if="addedServicesForAClientInmigrationActive"><span class="font-semibold">Servicio: </span>{{ this.addedServicesForAClientInmigrationActive.name_service }}</p>
              <p v-if="addedServicesForAClientInmigrationActive"><span class="font-semibold">Tipo de Visa: </span>{{ this.addedServicesForAClientInmigrationActive.name_visa_type }}</p>
            </div>
        </div>

        <!-- DOCUMENTO -->
        <div class="vx-row">
          <div class="vx-col w-full">
            <p v-if="this.name_visa_document_type"><span class="font-semibold">Documento a cargar: </span>{{ this.name_visa_document_type }}</p>
          </div>
        </div>

        <!-- CARGA Documento -->
        <div v-if="selectedFiles && selectedFiles.length">
          <div v-for="(file,i) in selectedFiles" :key="i" class="my-2 pb-2">
            <vs-divider/>
            <div class="pt-4 flex items-center justify-between">
              <div class="img-container mx-auto flex items-center justify-between gap-4">
                <img :src="file.url" alt="img" class="responsive" style="max-height: 140px; max-width: 280px;">
                <span v-if="file.type !== 'image/png' && file.type !== 'image/jpg' && file.type !== 'image/jpeg'">
                  {{ file.name }}
                </span>
              </div>
              <vs-button class="mx-4 px-5 hover:text-success" title="Borrar Archivo" color="dark" type="flat" icon-pack="feather" icon="icon-trash" @click.stop="removeFileFromSelected(file)"></vs-button>
            </div>
          </div>
        </div>
        <div class="upload-img py-4">
          <input type="file" multiple class="hidden" ref="uploadImgInputDocumento" @change="uploadFiles" accept=".jpg,.jpeg,.png,.pdf">
          <vs-button class="w-full" @click="$refs.uploadImgInputDocumento.click()">
            Cargar Archivos
          </vs-button>
        </div>
      </div>
    </VuePerfectScrollbar>
    <div class="flex flex-wrap items-center justify-between p-6" slot="footer">
      <vs-button @click="submitData()">Guardar</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    VuePerfectScrollbar
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        if (this.data.id_client) return
        this.selectedFiles = []
        this.$validator.reset()
      } else {
        const { id_visa_requirement, name_visa_document_type } = JSON.parse(JSON.stringify(this.data))
        this.id_visa_requirement = id_visa_requirement
        this.name_visa_document_type = name_visa_document_type
      }
    }
  },
  data () {
    return {
      id_visa_requirement: null,
      name_visa_document_type: null,
      selectedFiles: []
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    clientInfo () {
      return this.$store.state.clientInfo
    },
    roles () {
      if (this.$store.state.clientInfo.roles) return this.$store.state.clientInfo.roles.map(item => item.name_role).toString()
    },
    addedServicesForAClientInmigrationActive () {
      return this.$store.state.addedServicesForAClientInmigrationActive[0]
    }
  },
  methods: {
    uploadFiles (input) {
      const files = []
      if (input.target.files && input.target.files.length) {
        Array.from(input.target.files).forEach(file => {
          if (file.type === 'image/jpeg' || file.type === 'image/png') {
            const reader = new FileReader()
            reader.onload = e => { file.url = e.target.result }
            reader.readAsDataURL(file)
          } else if (file.type === 'application/pdf') {
            file.url = require('@/assets/images/doc_types/pdf_type.jpg')
          } else if (file.type === 'application/msword') {
            file.url = require('@/assets/images/doc_types/doc_type.jpg')
          } else if (file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
            file.url = require('@/assets/images/doc_types/docx_type.jpg')
          } else if (file.type === 'application/vnd.ms-excel') {
            file.url = require('@/assets/images/doc_types/xls_csv_type.jpg')
          } else if (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            file.url = require('@/assets/images/doc_types/xlsx_type.jpg')
          } else if (file.type === 'text/csv') {
            file.url = require('@/assets/images/doc_types/csv_type.jpg')
          } else if (file.type === 'text/plain') {
            file.url = require('@/assets/images/doc_types/txt_type.jpg')
          }
          // Add a small for reader.readAsDataURL 
          setTimeout(() => { files.push(file) }, 50)
        })
        this.selectedFiles = files
      }
    },
    removeFileFromSelected (remove) {
      const newSelectedFiles = this.selectedFiles.filter(i => {
        return i.name !== remove.name
      })
      this.selectedFiles = newSelectedFiles
    },
    submitData () {
      this.$vs.loading()
      const fd = new FormData()
      fd.append('id_visa_requirement', this.id_visa_requirement)
      
      if (this.selectedFiles && this.selectedFiles.length) {
        Array.from(this.selectedFiles).forEach(file => {
          fd.append('file[]', file, file.name)
        })
      }
      this.$store.dispatch('uploadFileVisaRequirement', fd)
        .then(res => {
          this.advisor_selected = res.data.advisor
          this.$emit('closeSidebarSuccess')
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Documento cargado',
            color: 'success',
            iconPack: 'feather',
            icon:'icon-check',
            time: 3000
          }) 
        })
        .catch(err => { 
          console.error(err)
          this.$vs.loading.close()
          const mensaje_error = err.response.data.errors
          if (typeof mensaje_error === 'string') {
            this.$vs.notify({
              title: 'Error',
              text: `${mensaje_error}`,
              color: 'warning',
              iconPack: 'feather',
              icon:'icon-x-circle',
              time: 6000
            })
          } else {
            const array_errors = Object.entries(mensaje_error)
            for (let i = 0; i < array_errors.length; i++) {
              this.$vs.notify({
                title: 'Error',
                text: `${array_errors[i][1][0]}`,
                iconPack: 'feather',
                icon: 'icon-x-circle',
                color: 'warning',
                time: 6000
              })
            }
          }
        })

      this.$emit('closeSidebar')
      // ex - Clear Field function
      this.selectedFiles = []
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }
  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;
    .img-upload {
      margin-top: 2rem;
      .con-img-upload {
        padding: 0;
      }
      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}
.scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
}
.demo-alignment {
  margin-top:-15px;
}
</style>
